import MultiSelect from './MultiSelect';

export default MultiSelect;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/MultiSelect/index.js